var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9928",
    "data-name": "Group 9928",
    transform: "translate(-791 -324.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3837",
    "data-name": "Group 3837",
    transform: "translate(791 324.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(15.582 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4156",
    "data-name": "Rectangle 4156",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3353",
    "data-name": "Group 3353",
    transform: "translate(19.478 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3352",
    "data-name": "Group 3352",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4157",
    "data-name": "Rectangle 4157",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355",
    transform: "translate(21.425 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3354",
    "data-name": "Group 3354",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4158",
    "data-name": "Rectangle 4158",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3357",
    "data-name": "Group 3357",
    transform: "translate(26.295 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4159",
    "data-name": "Rectangle 4159",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3359",
    "data-name": "Group 3359",
    transform: "translate(28.243 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3358",
    "data-name": "Group 3358",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4160",
    "data-name": "Rectangle 4160",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3361",
    "data-name": "Group 3361",
    transform: "translate(32.138 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3360",
    "data-name": "Group 3360",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4161",
    "data-name": "Rectangle 4161",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.331)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3363",
    "data-name": "Group 3363",
    transform: "translate(15.582 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3362",
    "data-name": "Group 3362",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4162",
    "data-name": "Rectangle 4162",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3365",
    "data-name": "Group 3365",
    transform: "translate(17.53 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3364",
    "data-name": "Group 3364",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4163",
    "data-name": "Rectangle 4163",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3367",
    "data-name": "Group 3367",
    transform: "translate(19.478 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3366",
    "data-name": "Group 3366",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4164",
    "data-name": "Rectangle 4164",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3369",
    "data-name": "Group 3369",
    transform: "translate(21.425 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3368",
    "data-name": "Group 3368",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4165",
    "data-name": "Rectangle 4165",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3371",
    "data-name": "Group 3371",
    transform: "translate(23.373 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3370",
    "data-name": "Group 3370",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4166",
    "data-name": "Rectangle 4166",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3373",
    "data-name": "Group 3373",
    transform: "translate(26.295 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4167",
    "data-name": "Rectangle 4167",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3375",
    "data-name": "Group 3375",
    transform: "translate(28.243 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3374",
    "data-name": "Group 3374",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4168",
    "data-name": "Rectangle 4168",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3377",
    "data-name": "Group 3377",
    transform: "translate(32.138 1.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3376",
    "data-name": "Group 3376",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4169",
    "data-name": "Rectangle 4169",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.278)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3379",
    "data-name": "Group 3379",
    transform: "translate(21.425 3.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3378",
    "data-name": "Group 3378",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4170",
    "data-name": "Rectangle 4170",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.228)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3381",
    "data-name": "Group 3381",
    transform: "translate(23.373 3.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3380",
    "data-name": "Group 3380",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4171",
    "data-name": "Rectangle 4171",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.228)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3383",
    "data-name": "Group 3383",
    transform: "translate(26.295 3.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3382",
    "data-name": "Group 3382",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4172",
    "data-name": "Rectangle 4172",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.228)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3385",
    "data-name": "Group 3385",
    transform: "translate(32.138 3.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3384",
    "data-name": "Group 3384",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4173",
    "data-name": "Rectangle 4173",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.228)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3387",
    "data-name": "Group 3387",
    transform: "translate(15.582 5.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3386",
    "data-name": "Group 3386",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4174",
    "data-name": "Rectangle 4174",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.175)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3389",
    "data-name": "Group 3389",
    transform: "translate(17.53 5.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3388",
    "data-name": "Group 3388",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4175",
    "data-name": "Rectangle 4175",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.175)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3391",
    "data-name": "Group 3391",
    transform: "translate(19.478 5.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3390",
    "data-name": "Group 3390",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4176",
    "data-name": "Rectangle 4176",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.175)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3393",
    "data-name": "Group 3393",
    transform: "translate(26.295 5.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3392",
    "data-name": "Group 3392",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4177",
    "data-name": "Rectangle 4177",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.175)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3395",
    "data-name": "Group 3395",
    transform: "translate(30.191 5.844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3394",
    "data-name": "Group 3394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4178",
    "data-name": "Rectangle 4178",
    width: 2,
    height: 2,
    transform: "translate(-0.19 -0.175)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3397",
    "data-name": "Group 3397",
    transform: "translate(19.478 7.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3396",
    "data-name": "Group 3396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4179",
    "data-name": "Rectangle 4179",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.122)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399",
    transform: "translate(26.295 7.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3398",
    "data-name": "Group 3398",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4180",
    "data-name": "Rectangle 4180",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.122)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3401",
    "data-name": "Group 3401",
    transform: "translate(28.243 7.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4181",
    "data-name": "Rectangle 4181",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.122)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3403",
    "data-name": "Group 3403",
    transform: "translate(30.191 7.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3402",
    "data-name": "Group 3402",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4182",
    "data-name": "Rectangle 4182",
    width: 2,
    height: 2,
    transform: "translate(-0.19 -0.122)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3405",
    "data-name": "Group 3405",
    transform: "translate(32.138 7.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3404",
    "data-name": "Group 3404",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4183",
    "data-name": "Rectangle 4183",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.122)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3407",
    "data-name": "Group 3407",
    transform: "translate(17.53 9.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3406",
    "data-name": "Group 3406",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4184",
    "data-name": "Rectangle 4184",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.069)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3409",
    "data-name": "Group 3409",
    transform: "translate(21.425 9.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3408",
    "data-name": "Group 3408",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4185",
    "data-name": "Rectangle 4185",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.069)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411",
    transform: "translate(28.243 9.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3410",
    "data-name": "Group 3410",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4186",
    "data-name": "Rectangle 4186",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.069)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3413",
    "data-name": "Group 3413",
    transform: "translate(15.582 11.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4187",
    "data-name": "Rectangle 4187",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.019)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(19.478 11.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4188",
    "data-name": "Rectangle 4188",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.019)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3417",
    "data-name": "Group 3417",
    transform: "translate(23.373 11.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3416",
    "data-name": "Group 3416",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4189",
    "data-name": "Rectangle 4189",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.019)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3419",
    "data-name": "Group 3419",
    transform: "translate(28.243 11.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3418",
    "data-name": "Group 3418",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4190",
    "data-name": "Rectangle 4190",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.019)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3421",
    "data-name": "Group 3421",
    transform: "translate(32.138 11.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3420",
    "data-name": "Group 3420",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4191",
    "data-name": "Rectangle 4191",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.019)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423",
    transform: "translate(15.582 13.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3422",
    "data-name": "Group 3422",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4192",
    "data-name": "Rectangle 4192",
    width: 2,
    height: 2,
    transform: "translate(0.418 0.034)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425",
    transform: "translate(17.53 13.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4193",
    "data-name": "Rectangle 4193",
    width: 1,
    height: 2,
    transform: "translate(0.471 0.034)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3427",
    "data-name": "Group 3427",
    transform: "translate(19.478 13.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4194",
    "data-name": "Rectangle 4194",
    width: 2,
    height: 2,
    transform: "translate(-0.479 0.034)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3429",
    "data-name": "Group 3429",
    transform: "translate(23.373 13.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3428",
    "data-name": "Group 3428",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4195",
    "data-name": "Rectangle 4195",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.034)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3431",
    "data-name": "Group 3431",
    transform: "translate(28.243 13.635)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3430",
    "data-name": "Group 3430",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4196",
    "data-name": "Rectangle 4196",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.034)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3433",
    "data-name": "Group 3433",
    transform: "translate(0 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3432",
    "data-name": "Group 3432",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4197",
    "data-name": "Rectangle 4197",
    width: 2,
    height: 2,
    transform: "translate(0 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3435",
    "data-name": "Group 3435",
    transform: "translate(3.896 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3434",
    "data-name": "Group 3434",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4198",
    "data-name": "Rectangle 4198",
    width: 2,
    height: 2,
    transform: "translate(0.104 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3437",
    "data-name": "Group 3437",
    transform: "translate(5.843 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3436",
    "data-name": "Group 3436",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4199",
    "data-name": "Rectangle 4199",
    width: 2,
    height: 2,
    transform: "translate(0.157 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3439",
    "data-name": "Group 3439",
    transform: "translate(9.739 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3438",
    "data-name": "Group 3438",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4200",
    "data-name": "Rectangle 4200",
    width: 2,
    height: 2,
    transform: "translate(0.262 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3441",
    "data-name": "Group 3441",
    transform: "translate(11.686 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3440",
    "data-name": "Group 3440",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4201",
    "data-name": "Rectangle 4201",
    width: 2,
    height: 2,
    transform: "translate(0.313 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3443",
    "data-name": "Group 3443",
    transform: "translate(13.634 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3442",
    "data-name": "Group 3442",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4202",
    "data-name": "Rectangle 4202",
    width: 2,
    height: 2,
    transform: "translate(0.366 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3445",
    "data-name": "Group 3445",
    transform: "translate(17.53 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3444",
    "data-name": "Group 3444",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4203",
    "data-name": "Rectangle 4203",
    width: 1,
    height: 2,
    transform: "translate(0.471 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3447",
    "data-name": "Group 3447",
    transform: "translate(23.373 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3446",
    "data-name": "Group 3446",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4204",
    "data-name": "Rectangle 4204",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3449",
    "data-name": "Group 3449",
    transform: "translate(28.243 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3448",
    "data-name": "Group 3448",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4205",
    "data-name": "Rectangle 4205",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3451",
    "data-name": "Group 3451",
    transform: "translate(32.138 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3450",
    "data-name": "Group 3450",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4206",
    "data-name": "Rectangle 4206",
    width: 2,
    height: 2,
    transform: "translate(-0.138 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3453",
    "data-name": "Group 3453",
    transform: "translate(36.034 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3452",
    "data-name": "Group 3452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4207",
    "data-name": "Rectangle 4207",
    width: 2,
    height: 2,
    transform: "translate(-0.034 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3455",
    "data-name": "Group 3455",
    transform: "translate(41.877 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3454",
    "data-name": "Group 3454",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4208",
    "data-name": "Rectangle 4208",
    width: 2,
    height: 2,
    transform: "translate(0.123 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3457",
    "data-name": "Group 3457",
    transform: "translate(45.772 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3456",
    "data-name": "Group 3456",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4209",
    "data-name": "Rectangle 4209",
    width: 2,
    height: 2,
    transform: "translate(0.228 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3459",
    "data-name": "Group 3459",
    transform: "translate(47.72 15.583)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3458",
    "data-name": "Group 3458",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4210",
    "data-name": "Rectangle 4210",
    width: 2,
    height: 2,
    transform: "translate(0.279 0.086)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3461",
    "data-name": "Group 3461",
    transform: "translate(0 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3460",
    "data-name": "Group 3460",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4211",
    "data-name": "Rectangle 4211",
    width: 2,
    height: 2,
    transform: "translate(0 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3463",
    "data-name": "Group 3463",
    transform: "translate(3.896 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3462",
    "data-name": "Group 3462",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4212",
    "data-name": "Rectangle 4212",
    width: 2,
    height: 2,
    transform: "translate(0.104 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3465",
    "data-name": "Group 3465",
    transform: "translate(7.791 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3464",
    "data-name": "Group 3464",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4213",
    "data-name": "Rectangle 4213",
    width: 2,
    height: 2,
    transform: "translate(0.209 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3467",
    "data-name": "Group 3467",
    transform: "translate(9.739 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3466",
    "data-name": "Group 3466",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4214",
    "data-name": "Rectangle 4214",
    width: 2,
    height: 2,
    transform: "translate(0.262 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3469",
    "data-name": "Group 3469",
    transform: "translate(13.634 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3468",
    "data-name": "Group 3468",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4215",
    "data-name": "Rectangle 4215",
    width: 2,
    height: 2,
    transform: "translate(0.366 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3471",
    "data-name": "Group 3471",
    transform: "translate(19.478 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3470",
    "data-name": "Group 3470",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4216",
    "data-name": "Rectangle 4216",
    width: 2,
    height: 2,
    transform: "translate(-0.479 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3473",
    "data-name": "Group 3473",
    transform: "translate(21.425 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3472",
    "data-name": "Group 3472",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4217",
    "data-name": "Rectangle 4217",
    width: 2,
    height: 2,
    transform: "translate(-0.425 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3475",
    "data-name": "Group 3475",
    transform: "translate(23.373 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3474",
    "data-name": "Group 3474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4218",
    "data-name": "Rectangle 4218",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3477",
    "data-name": "Group 3477",
    transform: "translate(32.138 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3476",
    "data-name": "Group 3476",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4219",
    "data-name": "Rectangle 4219",
    width: 2,
    height: 2,
    transform: "translate(-0.138 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3479",
    "data-name": "Group 3479",
    transform: "translate(34.086 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3478",
    "data-name": "Group 3478",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4220",
    "data-name": "Rectangle 4220",
    width: 2,
    height: 2,
    transform: "translate(-0.086 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3481",
    "data-name": "Group 3481",
    transform: "translate(37.982 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3480",
    "data-name": "Group 3480",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4221",
    "data-name": "Rectangle 4221",
    width: 2,
    height: 2,
    transform: "translate(0.019 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3483",
    "data-name": "Group 3483",
    transform: "translate(45.772 17.531)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3482",
    "data-name": "Group 3482",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4222",
    "data-name": "Rectangle 4222",
    width: 2,
    height: 2,
    transform: "translate(0.228 0.137)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3485",
    "data-name": "Group 3485",
    transform: "translate(3.896 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3484",
    "data-name": "Group 3484",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4223",
    "data-name": "Rectangle 4223",
    width: 2,
    height: 2,
    transform: "translate(0.104 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3487",
    "data-name": "Group 3487",
    transform: "translate(11.686 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3486",
    "data-name": "Group 3486",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4224",
    "data-name": "Rectangle 4224",
    width: 2,
    height: 2,
    transform: "translate(0.313 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3489",
    "data-name": "Group 3489",
    transform: "translate(17.53 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3488",
    "data-name": "Group 3488",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4225",
    "data-name": "Rectangle 4225",
    width: 1,
    height: 2,
    transform: "translate(0.471 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3491",
    "data-name": "Group 3491",
    transform: "translate(23.373 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3490",
    "data-name": "Group 3490",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4226",
    "data-name": "Rectangle 4226",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3493",
    "data-name": "Group 3493",
    transform: "translate(26.295 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4227",
    "data-name": "Rectangle 4227",
    width: 2,
    height: 2,
    transform: "translate(-0.295 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3495",
    "data-name": "Group 3495",
    transform: "translate(28.243 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3494",
    "data-name": "Group 3494",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4228",
    "data-name": "Rectangle 4228",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3497",
    "data-name": "Group 3497",
    transform: "translate(32.138 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3496",
    "data-name": "Group 3496",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4229",
    "data-name": "Rectangle 4229",
    width: 2,
    height: 2,
    transform: "translate(-0.138 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3499",
    "data-name": "Group 3499",
    transform: "translate(37.982 19.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3498",
    "data-name": "Group 3498",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4230",
    "data-name": "Rectangle 4230",
    width: 2,
    height: 2,
    transform: "translate(0.019 0.191)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3501",
    "data-name": "Group 3501",
    transform: "translate(0 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3500",
    "data-name": "Group 3500",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4231",
    "data-name": "Rectangle 4231",
    width: 2,
    height: 2,
    transform: "translate(0 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3503",
    "data-name": "Group 3503",
    transform: "translate(1.948 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3502",
    "data-name": "Group 3502",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4232",
    "data-name": "Rectangle 4232",
    width: 2,
    height: 2,
    transform: "translate(0.052 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3505",
    "data-name": "Group 3505",
    transform: "translate(3.896 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3504",
    "data-name": "Group 3504",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4233",
    "data-name": "Rectangle 4233",
    width: 2,
    height: 2,
    transform: "translate(0.104 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3507",
    "data-name": "Group 3507",
    transform: "translate(5.843 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3506",
    "data-name": "Group 3506",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4234",
    "data-name": "Rectangle 4234",
    width: 2,
    height: 2,
    transform: "translate(0.157 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3509",
    "data-name": "Group 3509",
    transform: "translate(7.791 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3508",
    "data-name": "Group 3508",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4235",
    "data-name": "Rectangle 4235",
    width: 2,
    height: 2,
    transform: "translate(0.209 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3511",
    "data-name": "Group 3511",
    transform: "translate(9.739 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3510",
    "data-name": "Group 3510",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4236",
    "data-name": "Rectangle 4236",
    width: 2,
    height: 2,
    transform: "translate(0.262 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3513",
    "data-name": "Group 3513",
    transform: "translate(13.634 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3512",
    "data-name": "Group 3512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4237",
    "data-name": "Rectangle 4237",
    width: 2,
    height: 2,
    transform: "translate(0.366 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3515",
    "data-name": "Group 3515",
    transform: "translate(15.582 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3514",
    "data-name": "Group 3514",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4238",
    "data-name": "Rectangle 4238",
    width: 2,
    height: 2,
    transform: "translate(0.418 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3517",
    "data-name": "Group 3517",
    transform: "translate(21.425 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3516",
    "data-name": "Group 3516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4239",
    "data-name": "Rectangle 4239",
    width: 2,
    height: 2,
    transform: "translate(-0.425 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3519",
    "data-name": "Group 3519",
    transform: "translate(23.373 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3518",
    "data-name": "Group 3518",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4240",
    "data-name": "Rectangle 4240",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3521",
    "data-name": "Group 3521",
    transform: "translate(26.295 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3520",
    "data-name": "Group 3520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4241",
    "data-name": "Rectangle 4241",
    width: 2,
    height: 2,
    transform: "translate(-0.295 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3523",
    "data-name": "Group 3523",
    transform: "translate(28.243 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3522",
    "data-name": "Group 3522",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4242",
    "data-name": "Rectangle 4242",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3525",
    "data-name": "Group 3525",
    transform: "translate(34.086 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3524",
    "data-name": "Group 3524",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4243",
    "data-name": "Rectangle 4243",
    width: 2,
    height: 2,
    transform: "translate(-0.086 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3527",
    "data-name": "Group 3527",
    transform: "translate(36.034 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3526",
    "data-name": "Group 3526",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4244",
    "data-name": "Rectangle 4244",
    width: 2,
    height: 2,
    transform: "translate(-0.034 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3529",
    "data-name": "Group 3529",
    transform: "translate(41.877 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3528",
    "data-name": "Group 3528",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4245",
    "data-name": "Rectangle 4245",
    width: 2,
    height: 2,
    transform: "translate(0.123 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3531",
    "data-name": "Group 3531",
    transform: "translate(43.825 21.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3530",
    "data-name": "Group 3530",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4246",
    "data-name": "Rectangle 4246",
    width: 2,
    height: 2,
    transform: "translate(0.175 0.244)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3533",
    "data-name": "Group 3533",
    transform: "translate(0 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3532",
    "data-name": "Group 3532",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4247",
    "data-name": "Rectangle 4247",
    width: 2,
    height: 3,
    transform: "translate(0 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3535",
    "data-name": "Group 3535",
    transform: "translate(11.686 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3534",
    "data-name": "Group 3534",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4248",
    "data-name": "Rectangle 4248",
    width: 2,
    height: 3,
    transform: "translate(0.313 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3537",
    "data-name": "Group 3537",
    transform: "translate(13.634 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3536",
    "data-name": "Group 3536",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4249",
    "data-name": "Rectangle 4249",
    width: 2,
    height: 3,
    transform: "translate(0.366 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3539",
    "data-name": "Group 3539",
    transform: "translate(19.478 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3538",
    "data-name": "Group 3538",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4250",
    "data-name": "Rectangle 4250",
    width: 2,
    height: 3,
    transform: "translate(-0.479 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3541",
    "data-name": "Group 3541",
    transform: "translate(21.425 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3540",
    "data-name": "Group 3540",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4251",
    "data-name": "Rectangle 4251",
    width: 2,
    height: 3,
    transform: "translate(-0.425 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3543",
    "data-name": "Group 3543",
    transform: "translate(26.295 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3542",
    "data-name": "Group 3542",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4252",
    "data-name": "Rectangle 4252",
    width: 2,
    height: 3,
    transform: "translate(-0.295 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3545",
    "data-name": "Group 3545",
    transform: "translate(28.243 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3544",
    "data-name": "Group 3544",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4253",
    "data-name": "Rectangle 4253",
    width: 2,
    height: 3,
    transform: "translate(-0.243 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3547",
    "data-name": "Group 3547",
    transform: "translate(34.086 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4254",
    "data-name": "Rectangle 4254",
    width: 2,
    height: 3,
    transform: "translate(-0.086 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3549",
    "data-name": "Group 3549",
    transform: "translate(36.034 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3548",
    "data-name": "Group 3548",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4255",
    "data-name": "Rectangle 4255",
    width: 2,
    height: 3,
    transform: "translate(-0.034 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    transform: "translate(37.982 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3550",
    "data-name": "Group 3550",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4256",
    "data-name": "Rectangle 4256",
    width: 2,
    height: 3,
    transform: "translate(0.019 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3553",
    "data-name": "Group 3553",
    transform: "translate(39.929 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3552",
    "data-name": "Group 3552",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4257",
    "data-name": "Rectangle 4257",
    width: 2,
    height: 3,
    transform: "translate(0.07 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3555",
    "data-name": "Group 3555",
    transform: "translate(43.825 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3554",
    "data-name": "Group 3554",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4258",
    "data-name": "Rectangle 4258",
    width: 2,
    height: 3,
    transform: "translate(0.175 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557",
    transform: "translate(45.772 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3556",
    "data-name": "Group 3556",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4259",
    "data-name": "Rectangle 4259",
    width: 2,
    height: 3,
    transform: "translate(0.228 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3559",
    "data-name": "Group 3559",
    transform: "translate(47.72 23.374)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4260",
    "data-name": "Rectangle 4260",
    width: 2,
    height: 3,
    transform: "translate(0.279 0.294)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3561",
    "data-name": "Group 3561",
    transform: "translate(1.948 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3560",
    "data-name": "Group 3560",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4261",
    "data-name": "Rectangle 4261",
    width: 2,
    height: 2,
    transform: "translate(0.052 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3563",
    "data-name": "Group 3563",
    transform: "translate(5.843 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3562",
    "data-name": "Group 3562",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4262",
    "data-name": "Rectangle 4262",
    width: 2,
    height: 2,
    transform: "translate(0.157 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3565",
    "data-name": "Group 3565",
    transform: "translate(7.791 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3564",
    "data-name": "Group 3564",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4263",
    "data-name": "Rectangle 4263",
    width: 2,
    height: 2,
    transform: "translate(0.209 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3567",
    "data-name": "Group 3567",
    transform: "translate(9.739 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3566",
    "data-name": "Group 3566",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4264",
    "data-name": "Rectangle 4264",
    width: 2,
    height: 2,
    transform: "translate(0.262 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3569",
    "data-name": "Group 3569",
    transform: "translate(13.634 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3568",
    "data-name": "Group 3568",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4265",
    "data-name": "Rectangle 4265",
    width: 2,
    height: 2,
    transform: "translate(0.366 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3571",
    "data-name": "Group 3571",
    transform: "translate(19.478 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3570",
    "data-name": "Group 3570",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4266",
    "data-name": "Rectangle 4266",
    width: 2,
    height: 2,
    transform: "translate(-0.479 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3573",
    "data-name": "Group 3573",
    transform: "translate(21.425 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3572",
    "data-name": "Group 3572",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4267",
    "data-name": "Rectangle 4267",
    width: 2,
    height: 2,
    transform: "translate(-0.425 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575",
    transform: "translate(26.295 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3574",
    "data-name": "Group 3574",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4268",
    "data-name": "Rectangle 4268",
    width: 2,
    height: 2,
    transform: "translate(-0.295 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3577",
    "data-name": "Group 3577",
    transform: "translate(28.243 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3576",
    "data-name": "Group 3576",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4269",
    "data-name": "Rectangle 4269",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3579",
    "data-name": "Group 3579",
    transform: "translate(30.191 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3578",
    "data-name": "Group 3578",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4270",
    "data-name": "Rectangle 4270",
    width: 2,
    height: 2,
    transform: "translate(-0.19 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3581",
    "data-name": "Group 3581",
    transform: "translate(32.138 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3580",
    "data-name": "Group 3580",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4271",
    "data-name": "Rectangle 4271",
    width: 2,
    height: 2,
    transform: "translate(-0.138 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3583",
    "data-name": "Group 3583",
    transform: "translate(36.034 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3582",
    "data-name": "Group 3582",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4272",
    "data-name": "Rectangle 4272",
    width: 2,
    height: 2,
    transform: "translate(-0.034 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3585",
    "data-name": "Group 3585",
    transform: "translate(37.982 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3584",
    "data-name": "Group 3584",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4273",
    "data-name": "Rectangle 4273",
    width: 2,
    height: 2,
    transform: "translate(0.019 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3587",
    "data-name": "Group 3587",
    transform: "translate(39.929 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3586",
    "data-name": "Group 3586",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4274",
    "data-name": "Rectangle 4274",
    width: 2,
    height: 2,
    transform: "translate(0.07 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3589",
    "data-name": "Group 3589",
    transform: "translate(47.72 26.295)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3588",
    "data-name": "Group 3588",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4275",
    "data-name": "Rectangle 4275",
    width: 2,
    height: 2,
    transform: "translate(0.279 0.375)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3591",
    "data-name": "Group 3591",
    transform: "translate(1.948 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3590",
    "data-name": "Group 3590",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4276",
    "data-name": "Rectangle 4276",
    width: 2,
    height: 2,
    transform: "translate(0.052 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3593",
    "data-name": "Group 3593",
    transform: "translate(3.896 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3592",
    "data-name": "Group 3592",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4277",
    "data-name": "Rectangle 4277",
    width: 2,
    height: 2,
    transform: "translate(0.104 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3595",
    "data-name": "Group 3595",
    transform: "translate(11.686 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3594",
    "data-name": "Group 3594",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4278",
    "data-name": "Rectangle 4278",
    width: 2,
    height: 2,
    transform: "translate(0.313 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3597",
    "data-name": "Group 3597",
    transform: "translate(13.634 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3596",
    "data-name": "Group 3596",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4279",
    "data-name": "Rectangle 4279",
    width: 2,
    height: 2,
    transform: "translate(0.366 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3599",
    "data-name": "Group 3599",
    transform: "translate(15.582 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3598",
    "data-name": "Group 3598",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4280",
    "data-name": "Rectangle 4280",
    width: 2,
    height: 2,
    transform: "translate(0.418 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3601",
    "data-name": "Group 3601",
    transform: "translate(23.373 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4281",
    "data-name": "Rectangle 4281",
    width: 3,
    height: 2,
    transform: "translate(-0.373 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3603",
    "data-name": "Group 3603",
    transform: "translate(28.243 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3602",
    "data-name": "Group 3602",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4282",
    "data-name": "Rectangle 4282",
    width: 2,
    height: 2,
    transform: "translate(-0.243 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3605",
    "data-name": "Group 3605",
    transform: "translate(34.086 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3604",
    "data-name": "Group 3604",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4283",
    "data-name": "Rectangle 4283",
    width: 2,
    height: 2,
    transform: "translate(-0.086 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3607",
    "data-name": "Group 3607",
    transform: "translate(39.929 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3606",
    "data-name": "Group 3606",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4284",
    "data-name": "Rectangle 4284",
    width: 2,
    height: 2,
    transform: "translate(0.07 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3609",
    "data-name": "Group 3609",
    transform: "translate(43.825 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3608",
    "data-name": "Group 3608",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4285",
    "data-name": "Rectangle 4285",
    width: 2,
    height: 2,
    transform: "translate(0.175 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3611",
    "data-name": "Group 3611",
    transform: "translate(45.772 28.243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3610",
    "data-name": "Group 3610",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4286",
    "data-name": "Rectangle 4286",
    width: 2,
    height: 2,
    transform: "translate(0.228 0.425)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3613",
    "data-name": "Group 3613",
    transform: "translate(0 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3612",
    "data-name": "Group 3612",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4287",
    "data-name": "Rectangle 4287",
    width: 2,
    height: 1,
    transform: "translate(0 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3615",
    "data-name": "Group 3615",
    transform: "translate(7.791 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3614",
    "data-name": "Group 3614",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4288",
    "data-name": "Rectangle 4288",
    width: 2,
    height: 1,
    transform: "translate(0.209 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3617",
    "data-name": "Group 3617",
    transform: "translate(9.739 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3616",
    "data-name": "Group 3616",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4289",
    "data-name": "Rectangle 4289",
    width: 2,
    height: 1,
    transform: "translate(0.262 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3619",
    "data-name": "Group 3619",
    transform: "translate(19.478 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3618",
    "data-name": "Group 3618",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4290",
    "data-name": "Rectangle 4290",
    width: 2,
    height: 1,
    transform: "translate(-0.479 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3621",
    "data-name": "Group 3621",
    transform: "translate(23.373 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3620",
    "data-name": "Group 3620",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4291",
    "data-name": "Rectangle 4291",
    width: 3,
    height: 1,
    transform: "translate(-0.373 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3623",
    "data-name": "Group 3623",
    transform: "translate(28.243 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3622",
    "data-name": "Group 3622",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4292",
    "data-name": "Rectangle 4292",
    width: 2,
    height: 1,
    transform: "translate(-0.243 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3625",
    "data-name": "Group 3625",
    transform: "translate(30.191 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3624",
    "data-name": "Group 3624",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4293",
    "data-name": "Rectangle 4293",
    width: 2,
    height: 1,
    transform: "translate(-0.19 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3627",
    "data-name": "Group 3627",
    transform: "translate(34.086 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3626",
    "data-name": "Group 3626",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4294",
    "data-name": "Rectangle 4294",
    width: 2,
    height: 1,
    transform: "translate(-0.086 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3629",
    "data-name": "Group 3629",
    transform: "translate(37.982 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3628",
    "data-name": "Group 3628",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4295",
    "data-name": "Rectangle 4295",
    width: 2,
    height: 1,
    transform: "translate(0.019 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3631",
    "data-name": "Group 3631",
    transform: "translate(39.929 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3630",
    "data-name": "Group 3630",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4296",
    "data-name": "Rectangle 4296",
    width: 2,
    height: 1,
    transform: "translate(0.07 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3633",
    "data-name": "Group 3633",
    transform: "translate(47.72 30.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3632",
    "data-name": "Group 3632",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4297",
    "data-name": "Rectangle 4297",
    width: 2,
    height: 1,
    transform: "translate(0.279 0.478)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3635",
    "data-name": "Group 3635",
    transform: "translate(3.896 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3634",
    "data-name": "Group 3634",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4298",
    "data-name": "Rectangle 4298",
    width: 2,
    height: 2,
    transform: "translate(0.104 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3637",
    "data-name": "Group 3637",
    transform: "translate(7.791 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3636",
    "data-name": "Group 3636",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4299",
    "data-name": "Rectangle 4299",
    width: 2,
    height: 2,
    transform: "translate(0.209 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3639",
    "data-name": "Group 3639",
    transform: "translate(11.686 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3638",
    "data-name": "Group 3638",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4300",
    "data-name": "Rectangle 4300",
    width: 2,
    height: 2,
    transform: "translate(0.313 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3641",
    "data-name": "Group 3641",
    transform: "translate(21.425 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3640",
    "data-name": "Group 3640",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4301",
    "data-name": "Rectangle 4301",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3643",
    "data-name": "Group 3643",
    transform: "translate(26.295 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3642",
    "data-name": "Group 3642",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4302",
    "data-name": "Rectangle 4302",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3645",
    "data-name": "Group 3645",
    transform: "translate(32.138 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3644",
    "data-name": "Group 3644",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4303",
    "data-name": "Rectangle 4303",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3647",
    "data-name": "Group 3647",
    transform: "translate(34.086 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3646",
    "data-name": "Group 3646",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4304",
    "data-name": "Rectangle 4304",
    width: 2,
    height: 2,
    transform: "translate(-0.086 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3649",
    "data-name": "Group 3649",
    transform: "translate(36.034 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3648",
    "data-name": "Group 3648",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4305",
    "data-name": "Rectangle 4305",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3651",
    "data-name": "Group 3651",
    transform: "translate(37.982 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3650",
    "data-name": "Group 3650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4306",
    "data-name": "Rectangle 4306",
    width: 2,
    height: 2,
    transform: "translate(0.019 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3653",
    "data-name": "Group 3653",
    transform: "translate(39.929 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3652",
    "data-name": "Group 3652",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4307",
    "data-name": "Rectangle 4307",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3655",
    "data-name": "Group 3655",
    transform: "translate(41.877 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3654",
    "data-name": "Group 3654",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4308",
    "data-name": "Rectangle 4308",
    width: 2,
    height: 2,
    transform: "translate(0.123 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3657",
    "data-name": "Group 3657",
    transform: "translate(43.825 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3656",
    "data-name": "Group 3656",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4309",
    "data-name": "Rectangle 4309",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3659",
    "data-name": "Group 3659",
    transform: "translate(45.772 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3658",
    "data-name": "Group 3658",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4310",
    "data-name": "Rectangle 4310",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3661",
    "data-name": "Group 3661",
    transform: "translate(47.72 32.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3660",
    "data-name": "Group 3660",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4311",
    "data-name": "Rectangle 4311",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.469)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3663",
    "data-name": "Group 3663",
    transform: "translate(15.582 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3662",
    "data-name": "Group 3662",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4312",
    "data-name": "Rectangle 4312",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3665",
    "data-name": "Group 3665",
    transform: "translate(17.53 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3664",
    "data-name": "Group 3664",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4313",
    "data-name": "Rectangle 4313",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3667",
    "data-name": "Group 3667",
    transform: "translate(19.478 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3666",
    "data-name": "Group 3666",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4314",
    "data-name": "Rectangle 4314",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3669",
    "data-name": "Group 3669",
    transform: "translate(23.373 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3668",
    "data-name": "Group 3668",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4315",
    "data-name": "Rectangle 4315",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3671",
    "data-name": "Group 3671",
    transform: "translate(32.138 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3670",
    "data-name": "Group 3670",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4316",
    "data-name": "Rectangle 4316",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673",
    transform: "translate(39.929 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3672",
    "data-name": "Group 3672",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4317",
    "data-name": "Rectangle 4317",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3675",
    "data-name": "Group 3675",
    transform: "translate(43.825 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3674",
    "data-name": "Group 3674",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4318",
    "data-name": "Rectangle 4318",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3677",
    "data-name": "Group 3677",
    transform: "translate(47.72 34.087)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3676",
    "data-name": "Group 3676",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4319",
    "data-name": "Rectangle 4319",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.419)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3679",
    "data-name": "Group 3679",
    transform: "translate(15.582 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3678",
    "data-name": "Group 3678",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4320",
    "data-name": "Rectangle 4320",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3681",
    "data-name": "Group 3681",
    transform: "translate(17.53 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3680",
    "data-name": "Group 3680",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4321",
    "data-name": "Rectangle 4321",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3683",
    "data-name": "Group 3683",
    transform: "translate(19.478 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3682",
    "data-name": "Group 3682",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4322",
    "data-name": "Rectangle 4322",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3685",
    "data-name": "Group 3685",
    transform: "translate(21.425 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3684",
    "data-name": "Group 3684",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4323",
    "data-name": "Rectangle 4323",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3687",
    "data-name": "Group 3687",
    transform: "translate(23.373 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3686",
    "data-name": "Group 3686",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4324",
    "data-name": "Rectangle 4324",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3689",
    "data-name": "Group 3689",
    transform: "translate(28.243 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3688",
    "data-name": "Group 3688",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4325",
    "data-name": "Rectangle 4325",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3691",
    "data-name": "Group 3691",
    transform: "translate(32.138 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3690",
    "data-name": "Group 3690",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4326",
    "data-name": "Rectangle 4326",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3693",
    "data-name": "Group 3693",
    transform: "translate(36.034 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3692",
    "data-name": "Group 3692",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4327",
    "data-name": "Rectangle 4327",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3695",
    "data-name": "Group 3695",
    transform: "translate(39.929 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3694",
    "data-name": "Group 3694",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4328",
    "data-name": "Rectangle 4328",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3697",
    "data-name": "Group 3697",
    transform: "translate(43.825 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3696",
    "data-name": "Group 3696",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4329",
    "data-name": "Rectangle 4329",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3699",
    "data-name": "Group 3699",
    transform: "translate(45.772 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3698",
    "data-name": "Group 3698",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4330",
    "data-name": "Rectangle 4330",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3701",
    "data-name": "Group 3701",
    transform: "translate(47.72 36.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3700",
    "data-name": "Group 3700",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4331",
    "data-name": "Rectangle 4331",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.366)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3703",
    "data-name": "Group 3703",
    transform: "translate(15.582 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3702",
    "data-name": "Group 3702",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4332",
    "data-name": "Rectangle 4332",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3705",
    "data-name": "Group 3705",
    transform: "translate(19.478 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3704",
    "data-name": "Group 3704",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4333",
    "data-name": "Rectangle 4333",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3707",
    "data-name": "Group 3707",
    transform: "translate(23.373 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3706",
    "data-name": "Group 3706",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4334",
    "data-name": "Rectangle 4334",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3709",
    "data-name": "Group 3709",
    transform: "translate(30.191 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3708",
    "data-name": "Group 3708",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4335",
    "data-name": "Rectangle 4335",
    width: 2,
    height: 2,
    transform: "translate(-0.19 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3711",
    "data-name": "Group 3711",
    transform: "translate(32.138 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3710",
    "data-name": "Group 3710",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4336",
    "data-name": "Rectangle 4336",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3713",
    "data-name": "Group 3713",
    transform: "translate(39.929 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3712",
    "data-name": "Group 3712",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4337",
    "data-name": "Rectangle 4337",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3715",
    "data-name": "Group 3715",
    transform: "translate(45.772 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3714",
    "data-name": "Group 3714",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4338",
    "data-name": "Rectangle 4338",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3717",
    "data-name": "Group 3717",
    transform: "translate(47.72 37.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3716",
    "data-name": "Group 3716",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4339",
    "data-name": "Rectangle 4339",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.314)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3719",
    "data-name": "Group 3719",
    transform: "translate(21.425 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3718",
    "data-name": "Group 3718",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4340",
    "data-name": "Rectangle 4340",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3721",
    "data-name": "Group 3721",
    transform: "translate(23.373 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3720",
    "data-name": "Group 3720",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4341",
    "data-name": "Rectangle 4341",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3723",
    "data-name": "Group 3723",
    transform: "translate(26.295 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3722",
    "data-name": "Group 3722",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4342",
    "data-name": "Rectangle 4342",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3725",
    "data-name": "Group 3725",
    transform: "translate(32.138 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3724",
    "data-name": "Group 3724",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4343",
    "data-name": "Rectangle 4343",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3727",
    "data-name": "Group 3727",
    transform: "translate(34.086 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3726",
    "data-name": "Group 3726",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4344",
    "data-name": "Rectangle 4344",
    width: 2,
    height: 2,
    transform: "translate(-0.086 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3729",
    "data-name": "Group 3729",
    transform: "translate(36.034 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3728",
    "data-name": "Group 3728",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4345",
    "data-name": "Rectangle 4345",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3731",
    "data-name": "Group 3731",
    transform: "translate(37.982 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3730",
    "data-name": "Group 3730",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4346",
    "data-name": "Rectangle 4346",
    width: 2,
    height: 2,
    transform: "translate(0.019 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3733",
    "data-name": "Group 3733",
    transform: "translate(39.929 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3732",
    "data-name": "Group 3732",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4347",
    "data-name": "Rectangle 4347",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3735",
    "data-name": "Group 3735",
    transform: "translate(41.877 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3734",
    "data-name": "Group 3734",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4348",
    "data-name": "Rectangle 4348",
    width: 2,
    height: 2,
    transform: "translate(0.123 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3737",
    "data-name": "Group 3737",
    transform: "translate(45.772 39.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3736",
    "data-name": "Group 3736",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4349",
    "data-name": "Rectangle 4349",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.261)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3739",
    "data-name": "Group 3739",
    transform: "translate(15.582 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3738",
    "data-name": "Group 3738",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4350",
    "data-name": "Rectangle 4350",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3741",
    "data-name": "Group 3741",
    transform: "translate(19.478 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3740",
    "data-name": "Group 3740",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4351",
    "data-name": "Rectangle 4351",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3743",
    "data-name": "Group 3743",
    transform: "translate(23.373 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3742",
    "data-name": "Group 3742",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4352",
    "data-name": "Rectangle 4352",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3745",
    "data-name": "Group 3745",
    transform: "translate(26.295 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3744",
    "data-name": "Group 3744",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4353",
    "data-name": "Rectangle 4353",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3747",
    "data-name": "Group 3747",
    transform: "translate(30.191 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3746",
    "data-name": "Group 3746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4354",
    "data-name": "Rectangle 4354",
    width: 2,
    height: 2,
    transform: "translate(-0.19 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(32.138 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3748",
    "data-name": "Group 3748",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4355",
    "data-name": "Rectangle 4355",
    width: 2,
    height: 2,
    transform: "translate(-0.138 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3751",
    "data-name": "Group 3751",
    transform: "translate(36.034 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3750",
    "data-name": "Group 3750",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4356",
    "data-name": "Rectangle 4356",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3753",
    "data-name": "Group 3753",
    transform: "translate(39.929 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3752",
    "data-name": "Group 3752",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4357",
    "data-name": "Rectangle 4357",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3755",
    "data-name": "Group 3755",
    transform: "translate(41.877 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3754",
    "data-name": "Group 3754",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4358",
    "data-name": "Rectangle 4358",
    width: 2,
    height: 2,
    transform: "translate(0.123 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3757",
    "data-name": "Group 3757",
    transform: "translate(43.825 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3756",
    "data-name": "Group 3756",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4359",
    "data-name": "Rectangle 4359",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3759",
    "data-name": "Group 3759",
    transform: "translate(45.772 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3758",
    "data-name": "Group 3758",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4360",
    "data-name": "Rectangle 4360",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3761",
    "data-name": "Group 3761",
    transform: "translate(47.72 41.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3760",
    "data-name": "Group 3760",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4361",
    "data-name": "Rectangle 4361",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.209)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3763",
    "data-name": "Group 3763",
    transform: "translate(15.582 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3762",
    "data-name": "Group 3762",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4362",
    "data-name": "Rectangle 4362",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3765",
    "data-name": "Group 3765",
    transform: "translate(19.478 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3764",
    "data-name": "Group 3764",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4363",
    "data-name": "Rectangle 4363",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3767",
    "data-name": "Group 3767",
    transform: "translate(21.425 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3766",
    "data-name": "Group 3766",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4364",
    "data-name": "Rectangle 4364",
    width: 2,
    height: 2,
    transform: "translate(-0.425 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3769",
    "data-name": "Group 3769",
    transform: "translate(23.373 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3768",
    "data-name": "Group 3768",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4365",
    "data-name": "Rectangle 4365",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3771",
    "data-name": "Group 3771",
    transform: "translate(26.295 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3770",
    "data-name": "Group 3770",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4366",
    "data-name": "Rectangle 4366",
    width: 2,
    height: 2,
    transform: "translate(-0.295 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3773",
    "data-name": "Group 3773",
    transform: "translate(34.086 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3772",
    "data-name": "Group 3772",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4367",
    "data-name": "Rectangle 4367",
    width: 2,
    height: 2,
    transform: "translate(-0.086 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3775",
    "data-name": "Group 3775",
    transform: "translate(36.034 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3774",
    "data-name": "Group 3774",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4368",
    "data-name": "Rectangle 4368",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3777",
    "data-name": "Group 3777",
    transform: "translate(39.929 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3776",
    "data-name": "Group 3776",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4369",
    "data-name": "Rectangle 4369",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3779",
    "data-name": "Group 3779",
    transform: "translate(43.825 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3778",
    "data-name": "Group 3778",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4370",
    "data-name": "Rectangle 4370",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3781",
    "data-name": "Group 3781",
    transform: "translate(45.772 43.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3780",
    "data-name": "Group 3780",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4371",
    "data-name": "Rectangle 4371",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.156)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3783",
    "data-name": "Group 3783",
    transform: "translate(17.53 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3782",
    "data-name": "Group 3782",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4372",
    "data-name": "Rectangle 4372",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3785",
    "data-name": "Group 3785",
    transform: "translate(19.478 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3784",
    "data-name": "Group 3784",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4373",
    "data-name": "Rectangle 4373",
    width: 2,
    height: 2,
    transform: "translate(-0.479 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3787",
    "data-name": "Group 3787",
    transform: "translate(30.191 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3786",
    "data-name": "Group 3786",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4374",
    "data-name": "Rectangle 4374",
    width: 2,
    height: 2,
    transform: "translate(-0.19 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3789",
    "data-name": "Group 3789",
    transform: "translate(34.086 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3788",
    "data-name": "Group 3788",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4375",
    "data-name": "Rectangle 4375",
    width: 2,
    height: 2,
    transform: "translate(-0.086 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3791",
    "data-name": "Group 3791",
    transform: "translate(36.034 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3790",
    "data-name": "Group 3790",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4376",
    "data-name": "Rectangle 4376",
    width: 2,
    height: 2,
    transform: "translate(-0.034 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3793",
    "data-name": "Group 3793",
    transform: "translate(39.929 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3792",
    "data-name": "Group 3792",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4377",
    "data-name": "Rectangle 4377",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3795",
    "data-name": "Group 3795",
    transform: "translate(43.825 45.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3794",
    "data-name": "Group 3794",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4378",
    "data-name": "Rectangle 4378",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.103)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3797",
    "data-name": "Group 3797",
    transform: "translate(15.582 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3796",
    "data-name": "Group 3796",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4379",
    "data-name": "Rectangle 4379",
    width: 2,
    height: 2,
    transform: "translate(0.418 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3799",
    "data-name": "Group 3799",
    transform: "translate(17.53 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3798",
    "data-name": "Group 3798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4380",
    "data-name": "Rectangle 4380",
    width: 1,
    height: 2,
    transform: "translate(0.471 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3801",
    "data-name": "Group 3801",
    transform: "translate(23.373 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3800",
    "data-name": "Group 3800",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4381",
    "data-name": "Rectangle 4381",
    width: 3,
    height: 2,
    transform: "translate(-0.373 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3803",
    "data-name": "Group 3803",
    transform: "translate(28.243 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3802",
    "data-name": "Group 3802",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4382",
    "data-name": "Rectangle 4382",
    width: 2,
    height: 2,
    transform: "translate(-0.243 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3805",
    "data-name": "Group 3805",
    transform: "translate(37.982 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3804",
    "data-name": "Group 3804",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4383",
    "data-name": "Rectangle 4383",
    width: 2,
    height: 2,
    transform: "translate(0.019 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3807",
    "data-name": "Group 3807",
    transform: "translate(39.929 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3806",
    "data-name": "Group 3806",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4384",
    "data-name": "Rectangle 4384",
    width: 2,
    height: 2,
    transform: "translate(0.07 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3809",
    "data-name": "Group 3809",
    transform: "translate(41.877 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3808",
    "data-name": "Group 3808",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4385",
    "data-name": "Rectangle 4385",
    width: 2,
    height: 2,
    transform: "translate(0.123 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3811",
    "data-name": "Group 3811",
    transform: "translate(43.825 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3810",
    "data-name": "Group 3810",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4386",
    "data-name": "Rectangle 4386",
    width: 2,
    height: 2,
    transform: "translate(0.175 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3813",
    "data-name": "Group 3813",
    transform: "translate(45.772 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3812",
    "data-name": "Group 3812",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4387",
    "data-name": "Rectangle 4387",
    width: 2,
    height: 2,
    transform: "translate(0.228 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3815",
    "data-name": "Group 3815",
    transform: "translate(47.72 47.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4388",
    "data-name": "Rectangle 4388",
    width: 2,
    height: 2,
    transform: "translate(0.279 -0.05)",
    fill: "#404040"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3818",
    "data-name": "Group 3818",
    transform: "translate(0.04 0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3817",
    "data-name": "Group 3817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3816",
    "data-name": "Group 3816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15505",
    "data-name": "Path 15505",
    d: "M49.052,42.022h-4.4a2.678,2.678,0,0,0-1.522.471,2.638,2.638,0,0,0-.811.89A2.541,2.541,0,0,0,42,44.622v4.5a2.631,2.631,0,0,0,2.654,2.6h4.4a2.631,2.631,0,0,0,2.654-2.6v-4.5A2.63,2.63,0,0,0,49.052,42.022Z",
    transform: "translate(-39.92 -39.943)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15506",
    "data-name": "Path 15506",
    d: "M9.131.022h-4.4A4.736,4.736,0,0,0,.194,3.374a4.593,4.593,0,0,0-.139.616A4.652,4.652,0,0,0,0,4.7V9.2a4.713,4.713,0,0,0,4.734,4.681h4.4A4.713,4.713,0,0,0,13.865,9.2V4.7A4.713,4.713,0,0,0,9.131.022ZM11.785,9.2a2.631,2.631,0,0,1-2.654,2.6h-4.4A2.631,2.631,0,0,1,2.08,9.2V4.7A2.543,2.543,0,0,1,2.4,3.464a2.638,2.638,0,0,1,.811-.89A2.677,2.677,0,0,1,4.734,2.1h4.4a2.63,2.63,0,0,1,2.654,2.6Z",
    transform: "translate(0 -0.022)",
    fill: "#404040"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3821",
    "data-name": "Group 3821",
    transform: "translate(35.694 0.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3820",
    "data-name": "Group 3820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3819",
    "data-name": "Group 3819"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15507",
    "data-name": "Path 15507",
    d: "M49.052,42.022h-4.4a2.678,2.678,0,0,0-1.522.471,2.638,2.638,0,0,0-.811.89A2.541,2.541,0,0,0,42,44.622v4.5a2.631,2.631,0,0,0,2.654,2.6h4.4a2.631,2.631,0,0,0,2.654-2.6v-4.5A2.63,2.63,0,0,0,49.052,42.022Z",
    transform: "translate(-39.92 -39.943)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15508",
    "data-name": "Path 15508",
    d: "M9.131.022h-4.4A4.736,4.736,0,0,0,.194,3.374a4.593,4.593,0,0,0-.139.616A4.652,4.652,0,0,0,0,4.7V9.2a4.713,4.713,0,0,0,4.734,4.681h4.4A4.713,4.713,0,0,0,13.865,9.2V4.7A4.713,4.713,0,0,0,9.131.022ZM11.785,9.2a2.631,2.631,0,0,1-2.654,2.6h-4.4A2.631,2.631,0,0,1,2.08,9.2V4.7A2.543,2.543,0,0,1,2.4,3.464a2.638,2.638,0,0,1,.811-.89A2.677,2.677,0,0,1,4.734,2.1h4.4a2.63,2.63,0,0,1,2.654,2.6Z",
    transform: "translate(0 -0.022)",
    fill: "#404040"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3824",
    "data-name": "Group 3824",
    transform: "translate(0.04 35.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3823",
    "data-name": "Group 3823",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3822",
    "data-name": "Group 3822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15509",
    "data-name": "Path 15509",
    d: "M49.052,42.022h-4.4a2.678,2.678,0,0,0-1.522.471,2.638,2.638,0,0,0-.811.89A2.541,2.541,0,0,0,42,44.622v4.5a2.631,2.631,0,0,0,2.654,2.6h4.4a2.631,2.631,0,0,0,2.654-2.6v-4.5A2.63,2.63,0,0,0,49.052,42.022Z",
    transform: "translate(-39.92 -39.943)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15510",
    "data-name": "Path 15510",
    d: "M9.131.022h-4.4A4.736,4.736,0,0,0,.194,3.374a4.593,4.593,0,0,0-.139.616A4.652,4.652,0,0,0,0,4.7V9.2a4.713,4.713,0,0,0,4.734,4.681h4.4A4.713,4.713,0,0,0,13.865,9.2V4.7A4.713,4.713,0,0,0,9.131.022ZM11.785,9.2a2.631,2.631,0,0,1-2.654,2.6h-4.4A2.631,2.631,0,0,1,2.08,9.2V4.7A2.543,2.543,0,0,1,2.4,3.464a2.638,2.638,0,0,1,.811-.89A2.677,2.677,0,0,1,4.734,2.1h4.4a2.63,2.63,0,0,1,2.654,2.6Z",
    transform: "translate(0 -0.022)",
    fill: "#404040"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3828",
    "data-name": "Group 3828",
    transform: "translate(4.001 4.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3827",
    "data-name": "Group 3827",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3826",
    "data-name": "Group 3826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3825",
    "data-name": "Group 3825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15511",
    "data-name": "Path 15511",
    d: "M1.609,5.942A1.612,1.612,0,0,1-.017,4.349V1.592a1.562,1.562,0,0,1,.2-.758,1.608,1.608,0,0,1,.5-.545A1.64,1.64,0,0,1,1.608,0H4.3A1.611,1.611,0,0,1,5.927,1.592V4.349A1.612,1.612,0,0,1,4.3,5.942H1.609Z",
    transform: "translate(0.017)",
    fill: "#404040"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3832",
    "data-name": "Group 3832",
    transform: "translate(39.654 4.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3831",
    "data-name": "Group 3831",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3830",
    "data-name": "Group 3830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_2",
    "data-name": "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3829",
    "data-name": "Group 3829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15512",
    "data-name": "Path 15512",
    d: "M1.609,5.942A1.612,1.612,0,0,1-.017,4.349V1.592a1.562,1.562,0,0,1,.2-.758,1.608,1.608,0,0,1,.5-.545A1.64,1.64,0,0,1,1.608,0H4.3A1.611,1.611,0,0,1,5.927,1.592V4.349A1.612,1.612,0,0,1,4.3,5.942H1.609Z",
    transform: "translate(0.017)",
    fill: "#404040"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3836",
    "data-name": "Group 3836",
    transform: "translate(4.001 39.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3835",
    "data-name": "Group 3835",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3834",
    "data-name": "Group 3834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_3",
    "data-name": "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3833",
    "data-name": "Group 3833"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15513",
    "data-name": "Path 15513",
    d: "M1.609,5.942A1.612,1.612,0,0,1-.017,4.349V1.592a1.562,1.562,0,0,1,.2-.758,1.608,1.608,0,0,1,.5-.545A1.64,1.64,0,0,1,1.608,0H4.3A1.611,1.611,0,0,1,5.927,1.592V4.349A1.612,1.612,0,0,1,4.3,5.942H1.609Z",
    transform: "translate(0.017)",
    fill: "#404040"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/QR.7c37ff4cb3651895cf31f62241a0121c.svg";
export { ForwardRef as ReactComponent };